import React from 'react';

import './styles.css';

const UpgradeButton = (
  {
    onClickUpgrade,
    getCouponContentKey,
    children,
  },
) => (
  <div className="action text-center">
    <button
      type="button"
      className="btn btn-lg btn-cta"
      onClick={onClickUpgrade}
    >
      {getCouponContentKey('upgradeButtonText', 'YES, UPGRADE ME!')}
      {children}
    </button>
  </div>
);

export default UpgradeButton;
